import type { ReactNode, SyntheticEvent } from 'react'
import type { CounterVariant, ThumbnailSize } from '@/tools/ui'

export enum ProductTileRowSize {
  small = 's',
  medium = 'm',
}

export interface ProductTileRowProps {
  children?: ReactNode
  counterVariant: CounterVariant
  description?: string
  imgAlt: string
  size: ProductTileRowSize
  imgSrc: string
  originalPrice?: string
  price: string
  tags?: ReactNode
  title: string
  quantity: number
  disabled?: boolean
  onAdd: (e?: SyntheticEvent<HTMLButtonElement>) => void
  onRemove: (e?: SyntheticEvent<HTMLButtonElement>) => void
  onClick?: (e?: SyntheticEvent<HTMLDivElement>) => void
}

export type ProductTileRowBodyProps = Omit<
  ProductTileRowProps,
  'children' | 'quantity' | 'onAdd' | 'onRemove' | 'size' | 'counterVariant'
> & { size: ThumbnailSize }
